import DataGrid, { Column } from 'devextreme-react/data-grid';
import { useContext } from 'react';
import { ROType } from '../../../../types/enums';
import { RetailOrderContext } from '../context/RetailOrderContext';

export default function RetailOrderProducts() {

    const { order } = useContext(RetailOrderContext);
    const isCabinetOrder = order.details.roTypeID === ROType.CabinetMeasureOrder || order.details.roTypeID === ROType.CabinetInstallOrder;

    return (
        <div className='dx-card wide-card'>
            <div className='grid-header'>Retail Order Details</div>
            <DataGrid
                dataSource={order.details.products.filter(x => !x.isGhostItem)}
                allowColumnReordering={true}
                allowColumnResizing={true}
                showBorders={true}
                showColumnLines={true}
                columnAutoWidth={true}
                keyExpr={'roProductID'}
                className="grid-with-header"
            >
                <Column
                    dataField={'itemDescription'}
                    caption={'Item Description'}
                    dataType="string"
                />
                <Column
                    dataField={'productLineDescription'}
                    caption={'Product Line'}
                    dataType="string"
                />
                <Column
                    dataField={'dealerSKU'}
                    caption={'SKU'}
                    dataType="string"
                />
                <Column
                    dataField={'dealerUOM'}
                    caption={'UOM'}
                    dataType="string"
                />
                <Column
                    dataField={'dealerQty'}
                    caption={'Qty'}
                    dataType="number"
                />
                {
                    !isCabinetOrder &&
                    <Column
                        dataField={'materialOrdered'}
                        caption={'Material Ordered'}
                        dataType="boolean"
                    />
                }
            </DataGrid>
        </div>
    );
}
